<template>
  <div
    class="company-block company-block-trainings mb-2"
    :class="{
      selected: selectedTraining && course.id == selectedTraining.id,
    }"
    @click.stop.prevent="setSelectedTraining"
  >
    <div class="select-training-list">
      <div>{{ course.name }}</div>
      <div>{{ course.locale }}</div>
      <div>
        {{ sessionsList.length }}
        <span v-if="sessionsList.length > 1">sessions</span>
        <span v-else>session</span>
      </div>
      <div></div>
      <div
        class="badge badge-icon badge-pill"
        :class="
          course.courseTypeSlug == 'e-learning' ||
          course.courseTypeSlug == 'virtual-class'
            ? 'badge-info badge-icon_pc '
            : course.courseTypeSlug == 'classroom'
            ? 'badge-info badge-icon_school'
            : 'badge-icon_combined badge-warning '
        "
      >
        {{ course.courseType }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseItem",
  props: {
    course: {
      required: true,
      type: Object,
      default: {},
    },
    index: {
      required: false,
      default: 0,
    },
    selectedTraining: {
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    sessionsList() {
      return this.$lodash.get(this.course, "sessions.data", []);
    },
  },
  methods: {
    setSelectedTraining() {
      this.$bus.$emit("update-selected-training", this.course);
    },
  },
};
</script>

<style></style>
